import { Box, Text } from 'dash-ui';
import styled from 'styled-components';

export const FeatureLabel = styled(Text)`
  flex: 1;
  ${({ isShort }: { isShort: boolean }) =>
    isShort &&
    `
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    `};
`;

export const GridStatusesWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.space * 2}px;
`;
